import React from "react";
import { useNavigate } from "react-router-dom";

export function VariantCard(props: any) {
  const data = props.data;
  //console.log(data);
  const navigate = useNavigate();

  function goToDetailsHandler(id:string) {
    navigate(`/product/${id}`);
  }

  return ( <div className="variants_section">
    {/* Show section only if there is more variants than 1 */}
    {data.length > 1 && <>
        <h4 >PRODUCT VARIANTS:</h4>
        <div className="variant_section" style={{ margin:"auto"}}>
            {data.map((el: { id: string; title: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; thumbnail: string | undefined; }) => {
                return(
                    <div className={`variant_element ${ props.selected === el.id ? "active_variant" : ""}`} key={el.id} onClick={()=> goToDetailsHandler(el.id)} >
                        <img className="variant_img" src={el.thumbnail} alt="product-variant" height="60px" width="60px" 
                        
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src="../img/no-img.png";
                              }}
                        />
                        <p className="variant_title">{el.title}</p>
                    </div>
                )
            })}
        </div>   
    </>}
  </div>);
}

